import { getNumberOfCols } from "@/utils/getNumberOfCols";

const FALLBACK_DESKTOP_COLUMN_COUNT = 4;
const FALLBACK_MOBILE_COLUMN_COUNT = 2;
const MOBILE_ROW_COUNT = 2;

type ComputeDiscoverSkeletonCountParameters = {
  containerWidth: number;
  colWidth: number;
  colGap: number;
  isMobile: boolean;
};

const computeDiscoverSkeletonCount = ({ containerWidth, colWidth, colGap, isMobile }: ComputeDiscoverSkeletonCountParameters): number => {
  const measuredColumns = getNumberOfCols({ containerWidth, colWidth, colGap });
  const fallbackColumns = isMobile ? FALLBACK_MOBILE_COLUMN_COUNT : FALLBACK_DESKTOP_COLUMN_COUNT;
  const columnCount = measuredColumns > 0 ? measuredColumns : fallbackColumns;

  return isMobile ? columnCount * MOBILE_ROW_COUNT : columnCount;
};

export default computeDiscoverSkeletonCount;
